import { PlatformDashboardFloatingAlertStore } from '../../shared/PlatformDashboardFloatingAlert';
import I18n from 'I18n';
export const handleErrorMessage = action => {
  PlatformDashboardFloatingAlertStore.addAlert({
    message: I18n.text('platformDashboard.quickFilter.fetchFailed', {
      action
    }),
    type: 'danger'
  });
};